import type { ProjectCountryCode } from '@/features/projects/countries';

export const LOCALES = [
  'en-US',
  'nb-NO',
  'pl-PL',
  'fi-FI',
  'sv-SE',
  'da-DK',
  'de-DE',
  'fr-FR',
  'pt-PT',
  'es-ES',
] as const;

export type Locale = (typeof LOCALES)[number];

export const LOCALE_COUNTRY_CODES: Record<Locale, ProjectCountryCode> = {
  'en-US': 'GB',
  'nb-NO': 'NO',
  'pl-PL': 'PL',
  'fi-FI': 'FI',
  'sv-SE': 'SE',
  'da-DK': 'DK',
  'de-DE': 'DE',
  'fr-FR': 'FR',
  'pt-PT': 'PT',
  'es-ES': 'ES',
};

export const LOCALE_COOKIE_KEY = 'volve_locale';

export const langToLocale: Record<string, string> = {
  en: 'en-US',
  nb: 'nb-NO',
};
